import React from "react";
import { Box } from "@material-ui/core";

interface IProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    className?: string;
}

type aProps = {
    id: string;
    "aria-controls": string;
};

const TabPanel: React.FC<IProps> = ({ children, index, value, ...other }) => (
    <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
    >
        {value === index && (
            <Box p={3} padding={0}>
                <>{children}</>
            </Box>
        )}
    </div>
);
export default TabPanel;

export const a11yProps = (index: number): aProps => ({
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
});
